import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Rating from 'components/Rating';
import { pluralize } from 'helpers';
import { toThousandsSeparator } from 'helpers/NumberFormats';

import styles from 'styles/components/productdetail/reviewSummary.scss';

const ReviewSummary = ({ rating, numReviews, productId }, { testId }) => {
  // remember that this is not the same as `numReviews <= 0`
  if (!(numReviews > 0)) {
    return null;
  }

  return (
    <Link to={`/product/review/${productId}`} data-test-id={testId('productReviews')}>
      <Rating
        additionalClasses={styles.ratingLayout}
        rating={rating}
        reviewCount={numReviews}
        forceDesktopRating={true}
        fullSize={true}/>
      <span className={styles.ratingLabel}>
        {toThousandsSeparator(numReviews)}
        {' '}
        {pluralize('Review', +numReviews)}
      </span>
    </Link>
  );
};

ReviewSummary.propTypes = {
  rating: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  numReviews: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  productId: PropTypes.string.isRequired
};

ReviewSummary.contextTypes = {
  testId: PropTypes.func
};

export default ReviewSummary;
